import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In 2019, WFP continued to provide support to families and communities to ensure that millions of people had sufficient nutritious food every day to feed their bodies and fuel their dreams. The European Commission remained an important partner in WFP’s drive towards Zero Hunger, helping us address the root causes of hunger and strengthen the resilience of the most vulnerable communities.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      